export type KnowledgeArticle = {
    id: number; title: string; summary?: string | null; content?: string;
    group?: string; nodeId?: number; rootNodeId?: number; articleKind?: string;
    readingTimeMinutes?: number; updatedAt?: string; isPinned?: boolean;
    searchExcerpt?: string; wikiUrl?: string; wikiBase?: string;
    breadcrumbs?: { id: number; name: string }[];
};
export type KnowledgeNode = { id: number; name: string; articleCount: number; items: KnowledgeNode[] };
export const kindNames: Record<string, string> = { guide: "Инструкция", reference: "Справочник", policy: "Регламент", faq: "Вопросы и ответы" };
export function nodeCount(node: KnowledgeNode): number { return node.articleCount + node.items.reduce((total, child) => total + nodeCount(child), 0); }
export function knowledgeUrl(raw: string, base: string): string | null {
    if (!raw.trim() || Array.from(raw).some(char => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)) return null;
    try { const url = new URL(raw, base + "/"); return ["https:", "http:", "mailto:", "tel:"].includes(url.protocol) ? url.href : null; }
    catch { return null; }
}
export function protectedFile(raw: string, base: string): string | null {
    try {
        const url = new URL(raw, base + "/");
        if (url.origin !== new URL(base).origin) return null;
        return /^\/api\/uploads\/([a-f0-9]{32})\/file$/.exec(url.pathname)?.[1] || null;
    } catch { return null; }
}
export function internalArticle(raw: string, base: string): string | null {
    try {
        const url = new URL(raw, base + "/");
        if (url.origin !== new URL(base).origin) return null;
        const match = /^\/articles\/([1-9]\d*)\/?$/.exec(url.pathname);
        return match ? "/knowledge/" + match[1] : null;
    } catch { return null; }
}
